import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path !== '/' && !to.path.endsWith('/')) {
    return navigateTo(`${to.path}/`, { replace: true })
  }
  if(to.path.indexOf('?') && !to.path.split('?')[0].endsWith('/')) {
    return navigateTo(`${to.path.split('?')[0]}/?${to.path.split('?')[1]}`, { replace: true })
  }
})